import AreaNames from "../../mixins/area-name-list-search";

Vue.component("inspection-area-update-form", {

  mixins: [AreaNames],

  props: ["area"],

  data() {
    return {
      inspectionArea: this.area,
      areaUpdateForm: new AppForm({
        name: ""
      })
    };
  },

  watch: {

    area: function(newValue) {
      this.inspectionArea = newValue;
      this.areaUpdateForm.name = this.inspectionArea.name;
    }

  },

  methods: {

    update() {

      App.patch("/inspections/areas/" + this.area.id + "/update", this.areaUpdateForm)
        .then(response => {
          toastr.success("Area updated!");
          this.$emit("area-updated", response);
        })
        .catch(() => {
          toastr.error("Error updating area!");
        });

    }

  }

});
